/**
 * Lang ISO interface
 */
interface LangISO {
  lang: string
  isoCode: string
}

/**
 * List of Code languages of tpv
 */
export const LangISOStore: LangISO[] = [
  { lang: 'es', isoCode: '001' },
  { lang: 'en', isoCode: '002' }
]
